<template>
  <v-btn
    fab
    color="error"
    class="btn-remover-cx"
    :x-small="!isMobile()"
    :small="isMobile()"
    @click.stop="removerProdutoCaixa()"
    ><v-icon>mdi-trash-can-outline</v-icon></v-btn
  >
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    caixa: { type: Object },
  },
  computed: mapState("formacaoCarga", ["cargaSelec"]),
  methods: {
    removerProdutoCaixa() {
      var pos = this.cargaSelec.dist_caixas.findIndex((cx) => cx.caixa == this.caixa.caixa);      
      if (pos >= 0) this.cargaSelec.dist_caixas.splice(pos, 1);
    },
    isMobile(){
      return this.$mq == 'sm'
    }
  },
};
</script>

<style>
.btn-remover-cx {
  position: absolute;
  left: -4px;
  top: -12px;
}
</style>